<template>
  <div class="select-area-mobile" :class="{ bordered: border }">
    <Field
      ref="field"
      v-model="selectedAreaName"
      is-link
      placeholder="请选择地区"
      clear-trigger="always"
      :clearable="allowClear && !disabled && !!areaCodeValue"
      :disabled="disabled"
      @click="handleFieldClick"
      @clear="clear"
    >
    </Field>
    <Popup v-model:show="showPopup" round :style="{ height: '80%' }" position="bottom">
      <Cascader
        v-model="areaCodeValue"
        v-bind="attrs"
        :field-names="fieldNames"
        :options="areaTree"
        @close="close"
        @change="change"
        @click-tab="clickTab"
      />
      <div class="btn-box">
        <Button type="primary" block @click="submit">确定</Button>
      </div>
    </Popup>
  </div>
</template>

<script lang="ts">
import { ref, useAttrs, watch } from 'vue'
import 'vant/es/field/style/index'
import { Field, Popup, Cascader, Button } from 'vant'
import {
  selectedValue,
  AreaTreeItem,
  selectAreaProps,
  getProvince,
  getCity,
  getDistrict,
  getStreet
} from './selectArea'
import 'vant/es/field/style/index'
import 'vant/es/popup/style/index'
import 'vant/es/cascader/style/index'
import 'vant/es/button/style/index'

export default {
  name: 'SelectAreaForMobile'
}
</script>
<script setup lang="ts">
const attrs: any = useAttrs()
const showPopup = ref(false) // 是否展示弹窗
let flag = true
let areaCodeValue: any = ref('') // 当前选中的值
let selectedAreaName = ref('不限') // 已经选择的区域，用于 field
let changedValue = ref({} as selectedValue) // 用于记录当前选中的数据
const props = defineProps(selectAreaProps)
const emits = defineEmits(['change', 'close', 'click-tab', 'clear', 'submit'])

const fieldNames = {
  text: 'areaName',
  value: 'areaCode',
  children: 'childAreaList'
}

const change = (val: selectedValue) => {
  changedValue.value = val // 记录当前选中的值
  emits('change', val)
}

const clickTab = (val: { tabIndex: number; title: string }) => {
  emits('click-tab', val)
}

const clear = () => {
  showPopup.value = false
  selectedAreaName.value = '不限'
  areaCodeValue.value = ''
  emits('clear')
}

const close = () => {
  showPopup.value = false
  emits('close')
}

const field = ref<HTMLInputElement | null>(null)
const handleFieldClick = () => {
  field.value?.blur()
  if (!props.disabled) showPopup.value = true
}

const submit = () => {
  showPopup.value = false
  const val = changedValue.value
  let selectOptions = val.selectedOptions
  const nameKey = fieldNames.text
  const valueKey = fieldNames.value
  if (selectOptions.length > 1) {
    selectOptions = selectOptions.filter((item) => item[valueKey])
  }
  selectedAreaName.value = ''
  // if (attrs['field-names']) {
  //   inputValKey = attrs['field-names'].text
  // }
  selectedAreaName.value = selectOptions.map((option) => option[nameKey]).join('/')
  emits('submit', val)
}

function setDefaultValue() {
  const areaCodeVal = props.areaCode
  const provinceCode = getProvince(areaCodeVal)
  const cityCode = getCity(areaCodeVal)
  const districtCode = getDistrict(areaCodeVal)
  const streetCode = getStreet(areaCodeVal)
  const areaTree = props.areaTree
  const provinceItem = areaTree.find((item: AreaTreeItem) => item.areaCode === provinceCode)
  const provinceName = provinceItem?.areaName
  const cityList = provinceItem?.childAreaList
  if (provinceName) selectedAreaName.value = provinceName
  areaCodeValue.value = provinceCode
  if (cityList && cityCode !== -1) {
    const cityItem = cityList.find((item: AreaTreeItem) => item.areaCode === cityCode)
    const cityName = cityItem?.areaName
    const districtList = cityItem?.childAreaList
    selectedAreaName.value = `${provinceName}/${cityName}`
    areaCodeValue.value = cityCode
    if (districtList && districtCode !== -1) {
      const districtItem = districtList.find((item: AreaTreeItem) => item.areaCode === districtCode)
      const districName = districtItem?.areaName
      selectedAreaName.value = `${provinceName}/${cityName}/${districName}`
      areaCodeValue.value = districtCode
    }
  }
}

watch(
  () => props.areaCode,
  (newVal, oldVal) => {
    if (oldVal !== newVal && newVal && flag) {
      setDefaultValue()
      flag = false
    } else if (!newVal) {
      selectedAreaName.value = '不限'
      areaCodeValue.value = ''
    }
  }
)
watch(
  () => props.areaTree,
  () => {
    if (props.areaCode && props.areaCode !== -1) {
      setDefaultValue()
    }
  }
)
</script>
